import React from 'react';
import CloseIcon from './../../images/close-icon.svg';
import { CloseButtonIconWrapper } from './styled';
import Icon from '../../ecoui/Icon';
import { withTheme } from 'styled-components';

const CloseButtonIcon = ({
    click = () => {},
    iconColor = '#fff',
    top,
    right,
    bC,
}) => {
    return (
        <CloseButtonIconWrapper onClick={click} right={right} top={top} bC={bC}>
            <Icon
                height={'13px'}
                width={'13px'}
                bold
                src={CloseIcon}
                color={iconColor}
            />
        </CloseButtonIconWrapper>
    );
};

export default withTheme(CloseButtonIcon);
